<mat-card>
  <h2 translate>edit.edit</h2>
  <mat-card-content>
    <form [formGroup]="editUserForm" (ngSubmit)="editUser()">
      <mat-grid-list cols="16" rowHeight="10px">
        <mat-grid-tile colspan="16" rowspan="6">
          <div fxFlex="100" fxLayout="row" fxLayoutAlign="space-between center">
            <mat-form-field fxFlex="50" appearance="outline">
              <mat-label translate>ownPassword.user</mat-label>
              <input id="userEditUser" #userEditUser formControlName="user" matInput type="text" autocomplete="off" />
            </mat-form-field>
            <div fxFlex="30" fxLayout="row" fxLayoutAlign="center center">
              <mat-form-field fxFlex="80" appearance="outline">
                <mat-label translate>edit.supplantedUser</mat-label>
                <input
                  id="supplantedUserEditUser"
                  #supplantedUserEditUser
                  formControlName="supplantedUser"
                  matInput
                  type="text"
                  autocomplete="off"
                />
              </mat-form-field>
              <button
                fxFlex="20"
                id="searchSupplantedButtonEditUser"
                type="button"
                fxFlex="100"
                mat-icon-button
                (click)="searchSupplanted()"
              >
                <mat-icon class="icon-ic_search"></mat-icon>
              </button>
            </div>
          </div>
        </mat-grid-tile>

        <mat-grid-tile colspan="16" [rowspan]="atributionsRows()">
          <div fxFlex="75" fxLayout="column" class="atribution-box">
            <mat-label><strong translate>edit.atribution</strong></mat-label>
            <div fxFlex="100" fxLayout="row wrap">
              <p fxFlex="32" *ngFor="let atribucion of userAtributionsList">{{ atribucion }}</p>
            </div>
          </div>
        </mat-grid-tile>

        <mat-grid-tile colspan="5" rowspan="6">
          <scf-custom-select-search
            fxFlex="100"
            formControlName="profile"
            [id]="'profileComboEditUser'"
            [dataInput]="profileList"
            [placeholder]="'edit.profile'"
            [isRequired]="true"
            [showErrors]="editUserForm?.controls?.profile?.errors"
            (onSelectionChange)="comboProfileSelection()"
          ></scf-custom-select-search>
        </mat-grid-tile>

        <mat-grid-tile colspan="1" rowspan="6"></mat-grid-tile>

        <mat-grid-tile colspan="4" rowspan="6">
          <scf-custom-select-search
            fxFlex="100"
            formControlName="brand"
            [id]="'brandComboEditUser'"
            [dataInput]="brandList"
            [placeholder]="'edit.brand'"
            [isRequired]="true"
            [showErrors]="editUserForm?.controls?.brand?.errors"
          ></scf-custom-select-search>
        </mat-grid-tile>

        <mat-grid-tile colspan="2" rowspan="6"></mat-grid-tile>

        <mat-grid-tile colspan="4" rowspan="6">
          <scf-custom-select-search
            fxFlex="100"
            formControlName="bankType"
            [id]="'bankTypeComboEditUser'"
            [dataInput]="bankTypeList"
            [placeholder]="'edit.bankType'"
            [isRequired]="true"
            [showErrors]="editUserForm?.controls?.bankType?.errors"
          ></scf-custom-select-search>
        </mat-grid-tile>

        <mat-grid-tile colspan="16" [rowspan]="availableAtributionsRows()">
          <div fxFlex="75" fxLayout="column" formGroupName="availableAtributions" class="atribution-box">
            <mat-label class="atribution-box-title"><strong translate>edit.atribution</strong></mat-label>
            <div fxFlex="100" fxLayout="row wrap" class="availableAtributions-box">
              <div fxFlex="32" *ngFor="let atribution of availableAtributionsList">
                <mat-checkbox
                  fxFlex="100"
                  id="atribution{{ atribution.atributionNumber }}EditUser"
                  color="accent"
                  [formControlName]="atribution.atributionNumber"
                >
                  {{ atribution.atributionName }}
                </mat-checkbox>
              </div>
            </div>
          </div>
        </mat-grid-tile>

        <mat-grid-tile colspan="5" rowspan="6">
          <mat-form-field fxFlex="100" appearance="outline">
            <mat-label translate>Password</mat-label>
            <input
              id="passwordEditUser"
              #passwordEditUser
              formControlName="password"
              matInput
              type="password"
              autocomplete="off"
            />
          </mat-form-field>
        </mat-grid-tile>

        <mat-grid-tile colspan="6" rowspan="6"></mat-grid-tile>

        <mat-grid-tile colspan="2" rowspan="6">
          <div fxFlex="100" fxLayout="row" fxLayoutAlign=" start" class="bottom-button">
            <button id="editSupplantedButtonEditUser" type="submit" fxFlex="100" mat-flat-button color="accent">
              <mat-label translate>edit.modify</mat-label>
            </button>
          </div>
        </mat-grid-tile>

        <mat-grid-tile colspan="1" rowspan="6"></mat-grid-tile>

        <mat-grid-tile colspan="2" rowspan="6">
          <div fxFlex="100" fxLayout="row" fxLayoutAlign=" start" class="bottom-button">
            <button
              id="removeSupplantedButtonEditUser"
              type="button"
              fxFlex="100"
              mat-flat-button
              (click)="removeUser()"
              color="accent"
            >
              <mat-label translate>edit.remove</mat-label>
            </button>
          </div>
        </mat-grid-tile>
      </mat-grid-list>
    </form>
  </mat-card-content>
</mat-card>
